// extracted by mini-css-extract-plugin
export var grid = "ListOfProfiles-module--grid--1416b";